import React, { useState, useEffect, useRef, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, Icon, Popup, Checkbox } from "semantic-ui-react";
import domtoimage from "dom-to-image";
import { capitalize, formatMoneyWithCurrency } from "src/utils/formatter";
import TableHeader from "src/components/flujocaja/TableHeader";
import useWindowDimensions from "src/utils/windowDimension";
import moment from "moment/moment";
import { UpdateCashflowCollapsed } from 'src/graphql/users'
import { importOpenSidebar } from "src/redux/actions/openSidebar";
import { UpdateCashflowCategories } from "src/redux/actions/auth";
import LoadingSpinner from "src/components/general/js/spinnerLoading"
import './style.scss'
import { CurrencyIcon } from "src/utils/currencyIcon";

const VIEW_TYPE = {
  day: 'day',
  week: 'week',
  month: 'month'
}

export default function Cashflow({
  getFlow,
  flowStructure,
  view,
  setNameSelected,
  tableHeight,
  start,
  end,
  loading,
  loadingMsg,
  checkSwitch,
  setCheckSwitch,
  updateCompress,
  setUpdateCompress,
  showAll,
}) {
  const screenshotRef = useRef(null)
  const handleCapturar = () => {
    if (screenshotRef.current) {
      domtoimage.toPng(screenshotRef.current).then(function (dataUrl) {
        var link = document.createElement("a");
        link.download = "flujo-caja.png";
        link.href = dataUrl;
        link.click();
      });
    }
  };
  const dispatch = useDispatch()
  const { cashflowCollapsedCategories } = useSelector((state) => state.auth)

  const { selectedCompany } = useSelector((state) => state.companyList)
  const [areasSelectedOnce, setAreasSelectedOnce] = useState([])
  const [compressedAreas, setCompressedAreas] = useState(cashflowCollapsedCategories)
  const [tableWidth, setTableWidth] = useState()
  const [selectedRow, setSelectedRow] = useState()
  const [startDate, setStartDate] = start
  const [endDate, setEndDate] = end

  const { width } = useWindowDimensions()
  const { openSidebar } = useSelector((state) => state.openSidebar)

  const [reportType, setReportType] = useState();
  const [selectedCashFlowAreaId, setSelectedCashFlowAreaId] = useState();
  const [selectedCashFlowCategoryId, setSelectedCashFlowCategoryId] = useState();
  const [selectedIndex, setSelectedIndex] = useState();

  const updateCashflowCollapsed = UpdateCashflowCollapsed()

  const res = tableWidth - 200
  const tot = Math.floor(res / 150)
  const maxRowNameWidth = true ? null : Math.min(4, Math.round(tot / 3))
  const [flowCurrentStructure] = flowStructure || []

  useEffect(() => {
    const totalWidth = document.getElementsByClassName("flowTableContainer")
    setTableWidth(totalWidth[0]?.clientWidth)

    if (openSidebar?.show == false) setSelectedRow()

  }, [width, openSidebar?.show])

  useEffect(() => {
    if (!openSidebar?.show || !getFlow || !openSidebar?.fieldDetail) return;
    const reports = getFlow.report[reportType];
    const selectedCashFlowCategory = reports?.find((cashFlow) => cashFlow.cashflowCategoryId == selectedCashFlowCategoryId)
    const selectedCashFlowArea = selectedCashFlowCategory?.fields?.find((cashFlowArea) => cashFlowArea.cashflowAreaId == selectedCashFlowAreaId)
    const value = selectedCashFlowArea?.values[selectedIndex];

    openFieldDetail(value, { selectedCashFlowArea }, selectedIndex, selectedCashFlowCategoryId, reportType); 

    if (value?.documents?.length === 0) {
      dispatch(importOpenSidebar({show: false}))
    }
  }, [getFlow])

  useEffect(() => {
    const lastViewDate = (value) => {
      return moment(startDate)
        .add(value, view)
        .endOf(view)
        .set('hours', 23)
        .set('minutes', 59)
        .set('seconds', 59)
        .format('YYYY-MM-DDTHH:mm:ss.SSS')
    }

    if (openSidebar?.show) {
      // if (tot <= 3) return setEndDate(lastViewDate(tot - (res > 555 ? 1 : res > 540 ? 0 : res > 520 ? 1 : 1)))
      // if (tot == 4) return setEndDate(lastViewDate(tot - 1))
      if (tot <= 4) return setEndDate(lastViewDate(3))
      if (tot == 5) return setEndDate(lastViewDate(tot - 1))
      if (tot >= 5) return setEndDate(lastViewDate(tot))
    }

    if (tot <= 5) return setEndDate(lastViewDate(tot - 3))
    if (tot >= 6) return setEndDate(lastViewDate(tot - 1))
  }, [tot, view, startDate])

  const compressAll = async ({ value }) => {
    if (value) {
      const companyCompressed = compressedAreas?.map((company) => {
        if (company?.companyId === selectedCompany?.id) {
          return { ...company, cashflowCategories: [] }
        }
        return { ...company }
      })
      const exist = companyCompressed?.find((f) => f?.companyId === selectedCompany?.id)
      if (!exist) companyCompressed?.push({ companyId: selectedCompany?.id, cashflowCategories: [] })
      setCompressedAreas(companyCompressed)
      dispatch(UpdateCashflowCategories(companyCompressed))
      const newData = companyCompressed?.find((f) => f?.companyId === selectedCompany?.id)
      await updateCashflowCollapsed({ companyId: newData?.companyId, categoryId: newData?.cashflowCategories })
    }
    if (!value) {
      const income = getFlow?.report?.INCOME?.filter((f) => {
        if (!f?.cashflowCategoryId) return
        // if (!f?.isVisible) return
        return f?.cashflowCategoryId
      })?.map((el) => el?.cashflowCategoryId)
      const expense = getFlow?.report?.EXPENSE?.filter((f) => {
        if (!f?.cashflowCategoryId) return
        // if (!f?.isVisible) return
        return f?.cashflowCategoryId
      })?.map((el) => el?.cashflowCategoryId)
      const allCompress = income?.concat(expense)
      const companyCompressed = compressedAreas?.map((company) => {
        if (company?.companyId === selectedCompany?.id) {
          return { ...company, cashflowCategories: allCompress }
        }
        return { ...company }
      })
      const exist = companyCompressed?.find((f) => f?.companyId === selectedCompany?.id)
      if (!exist) companyCompressed?.push({ companyId: selectedCompany?.id, cashflowCategories: [] })
      setCompressedAreas(companyCompressed)
      dispatch(UpdateCashflowCategories(companyCompressed))
      const newData = companyCompressed?.find((f) => f?.companyId === selectedCompany?.id)
      await updateCashflowCollapsed({ companyId: newData?.companyId, categoryId: newData?.cashflowCategories })
    }
  }

  useEffect(() => {
    if (compressedAreas?.find((f) => f?.companyId === selectedCompany?.id)?.cashflowCategories?.length === 0) {
      setCheckSwitch(true)
    }
    if (compressedAreas?.find((f) => f?.companyId === selectedCompany?.id)?.cashflowCategories?.length > 0) {
      setCheckSwitch(false)
    }
  }, [compressedAreas])

  useEffect(() => {
    if (updateCompress || loading) {
      compressAll({ value: checkSwitch })
      setUpdateCompress(false)
    }
  }, [updateCompress, loading])

  const currentFlow = useMemo(() => {

    if (flowCurrentStructure?.report && getFlow?.report) {
      const currentFlowStructure = flowCurrentStructure?.report
      const incomeTotal = getFlow.report.INCOME?.find(f => !f.cashflowCategoryId)
      const expenseTotal = getFlow.report.EXPENSE?.find(f => !f.cashflowCategoryId)
      currentFlowStructure?.INCOME.filter(f => f.cashflowCategoryId).push(incomeTotal)
      currentFlowStructure?.EXPENSE.filter(f => f.cashflowCategoryId).push(expenseTotal)

      return currentFlowStructure
    }

    return {}
  }, [flowCurrentStructure?.report, getFlow.report, getFlow?.companyId])


  if (loading) {
    return (
      <div className="containerTable">
        <div className="flowSpinner flowLoading">
          <LoadingSpinner
            height="60px"
            afterHeight="60px"
            afterWidth="60px"
          />
          <p className="pt-2">{loadingMsg}</p>
        </div>
        <div className="containerTable__cardPreLoader" style={{ height: "68vh" }}></div>
      </div>
    )
  }

  const openOrCloseCategory = async (e, selectedArea) => {
    if (!areasSelectedOnce.includes(selectedArea?.cashflowCategoryId)) {
      setAreasSelectedOnce([
        ...areasSelectedOnce,
        selectedArea?.cashflowCategoryId,
      ])
    }
    if (e.target.classList.contains("customRotateFC")) {
      const companyCompressed = compressedAreas.map((company) => {
        if (company?.companyId === selectedCompany?.id) {
          const filteredAreas = company?.cashflowCategories?.filter((category) => category !== selectedArea?.cashflowCategoryId)
          return { ...company, cashflowCategories: filteredAreas }
        }
        return { ...company }
      })
      const exist = companyCompressed?.find((f) => f?.companyId === selectedCompany?.id)
      if (!exist) companyCompressed?.push({ companyId: selectedCompany?.id, cashflowCategories: [] })
      dispatch(UpdateCashflowCategories(companyCompressed))
      setCompressedAreas(companyCompressed)
      const newData = companyCompressed?.find((f) => f?.companyId === selectedCompany?.id)
      await updateCashflowCollapsed({ companyId: newData?.companyId, categoryId: newData?.cashflowCategories })
      return e.target.classList.remove("customRotateFC")
    }
    const companyCompressed = compressedAreas?.map((company) => {
      if (company?.companyId === selectedCompany?.id) {
        const newCategories = company?.cashflowCategories
        newCategories?.push(selectedArea?.cashflowCategoryId)
        return { ...company }
      }
      return { ...company }
    })
    const exist = companyCompressed?.find((f) => f?.companyId === selectedCompany?.id)
    if (!exist) companyCompressed?.push({ companyId: selectedCompany?.id, cashflowCategories: [selectedArea?.cashflowCategoryId] })
    dispatch(UpdateCashflowCategories(companyCompressed))
    setCompressedAreas(companyCompressed)
    const newData = companyCompressed?.find((f) => f?.companyId === selectedCompany?.id)
    await updateCashflowCollapsed({ companyId: newData?.companyId, categoryId: newData?.cashflowCategories })
    return e.target.classList.add("customRotateFC")
  }

  const openFieldDetail = (value, { cashflowAreaId, isIncome, label }, index, cashFlowCategoryId, reportType) => {
    setReportType(reportType);
    setSelectedCashFlowAreaId(cashflowAreaId);
    setSelectedCashFlowCategoryId(cashFlowCategoryId);
    setSelectedIndex(index);

    setNameSelected(label)

    // const diff = moment(endDate).month() - moment(startDate).month() - 1
    const origin = moment(value?.start)
      .add(6, 'hour')
      .subtract(1, view)
      .startOf(view)
      .set('hours', 0)
      .set('minutes', 0)
      .set('seconds', 0)
      .format('YYYY-MM-DDTHH:mm:ss.SSS')

    // const final = moment(value.end)
    //   .add(2, view) // aqui iba el diff
    //   .endOf(view)
    //   .set('hours', 23)
    //   .set('minutes', 59)
    //   .set('seconds', 59)
    //   .format('YYYY-MM-DDTHH:mm:ss.SSS')

    setStartDate(origin)
    // setEndDate(final)
    setSelectedRow(`${cashflowAreaId}-cell${index}`)

    return dispatch(
      importOpenSidebar({
        show: true,
        fieldDetail: true,
        editData: { value, cashflowAreaId, isReceived: !isIncome }
      })
    )
  }

  const openBankDetail = (open) => {
    if (open) return dispatch(
      importOpenSidebar({
        show: true,
        initialBalance: true,
      })
    )
  }

  return (
    <div className="flowTableScroll" style={{ height: tableHeight - 225 }}>
      <div className="custom-screenshot-btn-fc">
        <Popup
          content="Tomar screenshot"
          position="top center"
          size="tiny"
          trigger={
            <Icon
              circular
              name="camera"
              color="blue"
              className="custom-screenshot-btn"
              onClick={handleCapturar}
            />
          }
        />
      </div>
      <div style={{ backgroundColor: "white", marginTop: "-20px" }} ref={screenshotRef}>
        <Table celled basic="very">
          <Table.Header id="table" className="stickyTableHeader">
            <Table.Row>
              <Table.HeaderCell />
              {getFlow.periods.map((period, index) => {
                if (period.start >= startDate && period.end <= endDate) {

                  let upper = ''
                  let lower = ''

                  if (getFlow.primaryView == VIEW_TYPE.month) {
                    upper = `${capitalize(moment(period.start).add(1, 'day').format("MMMM").replace('.', ''))}`
                    lower = `${(moment(period.start).add(6, 'hour').format("YYYY"))}`
                  }
                  if (getFlow.primaryView == VIEW_TYPE.week) {
                    upper = `Semana ${moment(period.start).format("DD")}`
                    lower = `de ${capitalize(moment(period.start).format("MMMM"))}`
                  }
                  if (getFlow.primaryView == VIEW_TYPE.day) {
                    upper = `${moment(period.start).format("dddd")} ${moment(period?.start).format("DD")}`
                    lower = `de ${capitalize(moment(period.start).format("MMMM"))}`
                  }

                  return (
                    <Table.HeaderCell key={`flowPeriod-${index}`} className="monthTitle">
                      <div className="d-flex flex-column">
                        <div className="newTitle">
                          {upper}
                        </div>
                        <div className="newTitle">
                          {lower}
                        </div>
                      </div>
                    </Table.HeaderCell>
                  )
                }
              })}

              <Table.HeaderCell className="monthTitleTotal">
                <label
                  className="newTitle d-flex justify-content-center"
                  style={{ color: "#0771ad" }}
                >
                  PROYECTADO
                </label>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body className="flowBody">

            <TableHeader title="SALDO INICIAL" />

            {getFlow.report.RESUME.map((field, row) => {

              if (row == 0) return

              return (
                <Table.Row key={`${field.label}-row`} className="flowBlueColor">
                  <Table.Cell className="px-2 totalCell" key={`${field.label}-label`} width={maxRowNameWidth}>
                    {/* { field.label.charAt(0).toUpperCase() + field.label.slice(1).toLowerCase()  } */}
                    {field.label}
                  </Table.Cell>
                  {field.values.map((value, index) => {
                    if (
                      (value?.start >= startDate && value?.end <= endDate) ||
                      value?.isTotal
                    ) {

                      const isResumeClickable =
                        getFlow.primaryView === VIEW_TYPE.month && moment(value.start).add(6, 'hour').format("MMYYYY") === moment().add(6, 'hour').format("MMYYYY") ||
                        getFlow.primaryView === VIEW_TYPE.week && moment(value.start).add(6, 'hour').startOf(VIEW_TYPE.week).format() === moment().add(6, 'hour').startOf(VIEW_TYPE.week).format() ||
                        getFlow.primaryView === VIEW_TYPE.day && moment(value.start).add(6, 'hour').format("DD-MM-YYYY") === moment().add(6, 'hour').format("DD-MM-YYYY")

                      return (
                        <Table.Cell
                          key={`${field.label}-cell${index}`}
                          onClick={() => openBankDetail(isResumeClickable && row > 0)}
                          className={`amountCell totalCell px-2 ${value?.isPast && "fcPasado"} ${field?.label === "Saldo inicial" && isResumeClickable ? "resumeClickable" : ""
                            }`}
                          style={{ borderTop: "1px solid #0771ad" }}
                        >
                          {value.fieldValue === 0 ? (
                            <div className="w-100 text-center">-</div>
                          ) : (
                            <div className="d-flex align-items-center">
                              <span
                                className={`${value?.fieldValue < 0 && "text-danger"
                                  } d-flex align-items-center`}
                              >
                                <Popup
                                  content={"Ver detalle"}
                                  position="left center"
                                  size="tiny"
                                  trigger={
                                    <Icon
                                      circular
                                      className="BankIconCashflow mr-2"
                                      name="university"
                                      style={{
                                        visibility:
                                          field?.label === "Saldo inicial" && isResumeClickable
                                            ? "visible"
                                            : "hidden",
                                      }}
                                    />
                                  }
                                />
                                {CurrencyIcon[value.currency]}{" "}
                              </span>
                              <span
                                className={`${value?.fieldValue < 0 && "text-danger"
                                  } text-end w-100`}
                              >
                                {formatMoneyWithCurrency(Math.round(value?.fieldValue), value.currency, false) || 0}
                              </span>
                            </div>
                          )}
                        </Table.Cell>
                      )
                    }

                  })}
                </Table.Row>
              )
            })}

            <TableHeader title="INGRESOS" />

            {getFlow.report.INCOME.map((income, index) => {

              const currentCategory = getFlow.report.INCOME?.find(f => f.cashflowCategoryId === income.cashflowCategoryId)
              return (
                <>
                  {income.fields.map((field, index) => {

                    const currentField = currentCategory?.fields?.find(f => f.cashflowAreaId === field.cashflowAreaId)
                    const className = `${!compressedAreas?.find(f => f?.companyId === selectedCompany?.id)?.cashflowCategories?.includes(income.cashflowCategoryId) && "colapsedArea"} ${compressedAreas?.find(f => f?.companyId === selectedCompany?.id)?.cashflowCategories?.includes(income.cashflowCategoryId) &&
                      areasSelectedOnce.includes(
                        income.cashflowCategoryId
                      ) &&
                      ""
                      // "openedArea"
                      }`

                    return (
                      (showAll || !field.isHidden) && (
                        <Table.Row
                          key={`${field.cashflowAreaId}-row${index}`}
                          className={className}
                          style={{ position: "relative" }}
                        >
                          {(field.isVisible || showAll) && (

                            <Table.Cell key={`${field.cashflowAreaId}-label`} className={`incomeOutcomeRow d-flex justify-content-between`} width={maxRowNameWidth}>
                              {/* { field.label.charAt(0).toUpperCase() + field.label.slice(1).toLowerCase() } */}
                              {field.label}
                              {showAll && field.isHidden && (
                                <Popup
                                content="Área oculta"  
                                position="top center"  
                                size="mini"  
                                inverted 
                                trigger={
                                  <Icon
                                    name="eye slash"
                                    style={{ color: '#acacac' }}
                                  />
                                }
                              />
                              )}
                            </Table.Cell>

                          )}
                          {field.values.map((value, index) => {

                            if (((value.start >= startDate && value.end <= endDate) || value.isTotal) && (field.isVisible || showAll)) {

                              const isCellSelected = selectedRow == `${field.cashflowAreaId}-cell${index}`

                              return (
                                <Table.Cell
                                  key={`${field.cashflowAreaId}-cell${index}`}
                                  onClick={() => openFieldDetail(value, field, index, currentCategory.cashflowCategoryId, 'INCOME')}
                                  className={`amountCell ${value.isTotal
                                    ? "totalCell"
                                    : "amount incomeOutcomeMoneyRow"
                                    } ${value.isLate && "useDelayesd"} ${value.isPast && "fcPasado"
                                    } ${isCellSelected ? "SelectedRow" : ""}`}
                                >
                                  {value.fieldValue === 0 ? (
                                    <div className="w-100 text-center">-</div>
                                  ) : (
                                    <div className="d-flex align-items-center">
                                      <span className="d-flex align-items-center">
                                        <Popup
                                          content={
                                            field.isProjected
                                              ? "Ya tienes DTEs, tal vez quieras bajar la proyección"
                                              : "Hay pagos atrasados en esta área"
                                          }
                                          position="left center"
                                          size="tiny"
                                          trigger={
                                            <Icon
                                              circular
                                              size="tiny"
                                              className={`${field.isProjected
                                                ? "exclamationIconProjection"
                                                : "exclamationIcon"
                                                } mr-2`}
                                              name="exclamation"
                                              style={{
                                                visibility: value.isLate
                                                  ? "visible"
                                                  : "hidden",
                                              }}
                                            />
                                          }
                                        />
                                        {CurrencyIcon[value.currency]}{" "}
                                      </span>
                                      <span className="text-end w-100">
                                        {formatMoneyWithCurrency(
                                          Math.round(value.fieldValue), value.currency, '', false
                                        ) || 0}
                                      </span>
                                    </div>
                                  )}
                                </Table.Cell>
                              )
                            }
                          })}
                        </Table.Row>
                      )
                    );
                  })}

                  {(income.isVisible || showAll) && <Table.Row key={`${income.cashflowCategoryId}`} className="position-relative">
                    <Table.Cell key={`${income.cashflowCategoryId}-label`} className={`${income.cashflowCategoryId ? "subTotal" : "categoryTotal"} incomeOutcomeRow`}>
                      <div className="d-flex justify-content-between">
                        <span>{income.label}</span>
                        {income.cashflowCategoryId && (
                          <Icon
                            name="angle up"
                            className={`clicableAngleFc ${compressedAreas?.find(f => f?.companyId === selectedCompany?.id)?.cashflowCategories?.includes(income.cashflowCategoryId) && "customRotateFC"}`}
                            onClick={(e) => openOrCloseCategory(e, income)}
                          />
                        )}
                      </div>
                    </Table.Cell>

                    {currentCategory.values.map((value, index) => {


                      if (
                        (value.start >= startDate && value.end <= endDate) || value.isTotal) {
                        return (
                          <Table.Cell
                            key={`${income.cashflowCategoryId}-cell${index}`}
                            className={`amountCell ${value.isPast && "fcPasado"
                              } ${value.isTotal
                                ? "totalCell"
                                : income?.cashflowCategoryId
                                  ? "subTotal incomeOutcomeMoneyRow"
                                  : "categoryTotal incomeOutcomeMoneyRow"
                              }`}
                          >
                            {value.fieldValue === 0 ? (
                              <div className="w-100 text-center">-</div>
                            ) : (
                              <div className="d-flex align-items-center">
                                <span className="d-flex align-items-center">
                                  <Popup
                                    content={"Hay pagos atrasados en esta área"}
                                    position="left center"
                                    size="tiny"
                                    trigger={
                                      <Icon
                                        circular
                                        size="tiny"
                                        className={`${"exclamationIcon"} mr-2`}
                                        name="exclamation"
                                        style={{
                                          visibility: "hidden",
                                        }}
                                      />
                                    }
                                  />
                                  {CurrencyIcon[value.currency]}{" "}
                                </span>
                                <span className="text-end w-100">
                                  {formatMoneyWithCurrency(Math.round(value.fieldValue), value.currency, false) ||
                                    0}
                                </span>
                              </div>
                            )}
                          </Table.Cell>
                        )
                      }
                    }
                    )}
                  </Table.Row>}
                </>
              );
            })}

            <TableHeader title="EGRESOS" />

            {getFlow.report.EXPENSE.map((expense, index) => {

              const currentCategory = getFlow.report.EXPENSE?.find(f => f.cashflowCategoryId === expense.cashflowCategoryId)
              return (
                <>
                  {expense?.fields?.map((field, index) => {

                    const currentField = currentCategory?.fields?.find(f => f.cashflowAreaId === field.cashflowAreaId)
                    const className = `${!compressedAreas?.find(f => f?.companyId === selectedCompany?.id)?.cashflowCategories?.includes(expense.cashflowCategoryId) && "colapsedArea"} ${compressedAreas?.find(f => f?.companyId === selectedCompany?.id)?.cashflowCategories?.includes(expense.cashflowCategoryId) &&
                      areasSelectedOnce.includes(
                        expense.cashflowCategoryId
                      ) &&
                      "openedArea"
                      }`
                    return (
                      (showAll || !field.isHidden) && (
                        <Table.Row
                          key={`${field.cashflowAreaId}-row${index}`}
                          className={className}
                          style={{ position: "relative" }}
                        >
                          {(field?.isVisible || showAll) && (
                            <Table.Cell key={`${field.cashflowAreaId}-label`} className="incomeOutcomeRow px-2 d-flex justify-content-between" width={maxRowNameWidth}>
                              {/* { field.label.charAt(0).toUpperCase() + field.label.slice(1).toLowerCase() } */}
                              {field.label}
                              {showAll && field.isHidden && (
                                <Popup
                                content="Área oculta"  
                                position="top center"  
                                size="mini"  
                                inverted 
                                trigger={
                                  <Icon
                                    name="eye slash"
                                    style={{ color: '#acacac' }}
                                  />
                                }
                              />
                              )}
                            </Table.Cell>
                          )}
                          {field?.values?.map((value, index) => {
                            if (
                              ((value.start >= startDate &&
                                value.end <= endDate) ||
                                value.isTotal) &&
                              (field?.isVisible || showAll)
                            ) {
                              const isCellSelected = selectedRow == `${field.cashflowAreaId}-cell${index}`

                              return (
                                <Table.Cell
                                  key={`${field.cashflowAreaId}-cell${index}`}
                                  onClick={() => openFieldDetail(value, field, index, currentCategory.cashflowCategoryId, 'EXPENSE')}
                                  className={`amountCell ${value.isTotal
                                    ? "totalCell"
                                    : "amount incomeOutcomeMoneyRow"
                                    } ${value.isLate && "useDelayesd"} ${value.isPast && "fcPasado"
                                    } ${isCellSelected ? "SelectedRow" : ""}`}
                                >
                                  {value.fieldValue === 0 ? (
                                    <div className="text-center w-100">-</div>
                                  ) : (
                                    <>
                                      <div className="d-flex align-items-center">
                                        <span className="d-flex align-items-center">
                                          <Popup
                                            content={
                                              field.isProjected
                                                ? "Ya tienes DTEs, tal vez quieras bajar la proyección"
                                                : "Hay pagos atrasados en esta área"
                                            }
                                            position="left center"
                                            size="tiny"
                                            trigger={
                                              <Icon
                                                circular
                                                size="tiny"
                                                className={`${field.isProjected
                                                  ? "exclamationIconProjection"
                                                  : "exclamationIcon"
                                                  } mr-2`}
                                                name="exclamation"
                                                style={{
                                                  visibility: value.isLate
                                                    ? "visible"
                                                    : "hidden",
                                                }}
                                              />
                                            }
                                          />
                                          {CurrencyIcon[value.currency]}{" "}
                                        </span>
                                        <span className="text-end w-100">
                                          {formatMoneyWithCurrency(
                                            Math.round(value.fieldValue), value.currency, false
                                          ) || 0}
                                        </span>
                                      </div>
                                    </>
                                  )}
                                </Table.Cell>
                              );
                            }
                          })}
                        </Table.Row>
                      )
                    );
                  })}

                  {(expense.isVisible || showAll) && <Table.Row key={`${expense.cashflowCategoryId}`} className="position-relative">
                    <Table.Cell
                      key={`${expense.cashflowCategoryId}-label`}
                      className={`${expense?.cashflowCategoryId
                        ? "subTotal"
                        : "outCategoryTotal"
                        } incomeOutcomeRow`} width={maxRowNameWidth}
                    >
                      <div className="d-flex justify-content-between">
                        <span>{expense?.label}</span>
                        {expense?.cashflowCategoryId && (
                          <Icon
                            name="angle up"
                            className={`clicableAngleFc ${compressedAreas?.find(f => f?.companyId === selectedCompany?.id)?.cashflowCategories?.includes(expense.cashflowCategoryId) && "customRotateFC"}`}
                            onClick={(e) => openOrCloseCategory(e, expense)}
                          />
                        )}
                      </div>
                    </Table.Cell>
                    {expense?.values?.map((value, index) => {
                      if (
                        (value.start >= startDate && value.end <= endDate) ||
                        value.isTotal
                      )
                        return (
                          <Table.Cell
                            key={`${expense.cashflowCategoryId}-cell${index}`}
                            className={`amountCell ${value.isPast && "fcPasado"
                              } ${value.isTotal
                                ? "totalCell"
                                : expense?.cashflowCategoryId
                                  ? "subTotal incomeOutcomeMoneyRow"
                                  : "outCategoryTotal incomeOutcomeMoneyRow"
                              }`}
                          >
                            {value.fieldValue === 0 ? (
                              <div className="w-100 text-center">-</div>
                            ) : (
                              <div className="d-flex align-items-center">
                                <span className="d-flex align-items-center">
                                  <Popup
                                    content={"Hay pagos atrasados en esta área"}
                                    position="left center"
                                    size="tiny"
                                    trigger={
                                      <Icon
                                        circular
                                        size="tiny"
                                        className={`${"exclamationIcon"} mr-2`}
                                        name="exclamation"
                                        style={{
                                          visibility: "hidden",
                                        }}
                                      />
                                    }
                                  />
                                  {CurrencyIcon[value.currency]}{" "}
                                </span>
                                <span className="text-end w-100">
                                  {formatMoneyWithCurrency(Math.round(value.fieldValue), value.currency, false) ||
                                    0}
                                </span>
                              </div>
                            )}
                          </Table.Cell>
                        );
                    })}
                  </Table.Row>}
                </>
              );
            })}

            <TableHeader title="VARIACIÓN DE CAJA" />

            {getFlow.report.RESUME.map((field, row) => {

              if (row > 0) return

              return (
                <Table.Row key={`${field.label}-row`}>
                  <Table.Cell className="resumeCell px-2" key={`${field.label}-label`} width={maxRowNameWidth}>
                    {field.label}
                  </Table.Cell>
                  {field.values.map((value, index) => {
                    if (
                      (value?.start >= startDate && value?.end <= endDate) ||
                      value?.isTotal
                    ) {

                      const isResumeClickable =
                        getFlow.primaryView === VIEW_TYPE.month && moment(value.start).format("MMYYYY") === moment().format("MMYYYY") ||
                        getFlow.primaryView === VIEW_TYPE.week && moment(value.start).startOf(VIEW_TYPE.week).format() === moment().startOf(VIEW_TYPE.week).format() ||
                        getFlow.primaryView === VIEW_TYPE.day && moment(value.start).format("DD-MM-YYYY") === moment().format("DD-MM-YYYY")

                      return (
                        <Table.Cell
                          key={`${field.label}-cell${index}`}
                          onClick={() => openBankDetail(isResumeClickable && row > 0)}
                          className={`amountCell ${value?.isTotal ? "totalCell" : "resumeCell"
                            } ${value?.isPast && "fcPasado"} ${field?.label === "Saldo inicial" && isResumeClickable ? "resumeClickable" : ""
                            }`}
                          style={{ borderTop: "1px solid #0771ad" }}
                        >
                          {value.fieldValue === 0 ? (
                            <div className="w-100 text-center">-</div>
                          ) : (
                            <div className="d-flex align-items-center">
                              <span
                                className={`${value?.fieldValue < 0 && "text-danger"
                                  } d-flex align-items-center`}
                              >
                                <Popup
                                  content={"Ver detalle"}
                                  position="left center"
                                  size="tiny"
                                  trigger={
                                    <Icon
                                      circular
                                      className="BankIconCashflow mr-2"
                                      name="university"
                                      style={{
                                        visibility:
                                          field?.label === "Saldo inicial" && isResumeClickable
                                            ? "visible"
                                            : "hidden",
                                      }}
                                    />
                                  }
                                />
                                {CurrencyIcon[value.currency]}{" "}
                              </span>
                              <span
                                className={`${value?.fieldValue < 0 && "text-danger"
                                  } text-end w-100`}
                              >
                                {formatMoneyWithCurrency(Math.round(value?.fieldValue), value.currency, false) || 0}
                              </span>
                            </div>
                          )}
                        </Table.Cell>
                      )
                    }

                  })}
                </Table.Row>
              );
            })}

            {/* <TableHeader title="TOTAL" /> */}

            {getFlow?.report?.TOTAL?.map((total, index) => {
              return (
                <Table.Row key={`${total.label}-row`} className="stickyTableBottom flowBlueColor">
                  <Table.Cell key={`${total.label}-label`} className="totalCell px-2" width={maxRowNameWidth}>
                    {total.label}
                  </Table.Cell>
                  {total?.values?.map((value, index) => {
                    if (
                      (value?.start >= startDate && value?.end <= endDate) ||
                      value?.isTotal
                    )
                      return (
                        <Table.Cell
                          key={`${total.label}-cell${index}`}
                          className={`amountCell totalCell px-2 ${value?.isPast && "fcPasado"
                            }`}
                        >
                          {value?.fieldValue === 0 ? (
                            <div className="w-100 text-center">-</div>
                          ) : (
                            <div className="d-flex align-items-center">
                              <span
                                className={`${value?.fieldValue < 0 && "text-danger"
                                  } d-flex align-items-center`}
                              >
                                <Popup
                                  content={"Hay pagos atrasados en esta área"}
                                  position="left center"
                                  size="tiny"
                                  trigger={
                                    <Icon
                                      circular
                                      size="tiny"
                                      className={`${"exclamationIcon"} mr-2`}
                                      name="exclamation"
                                      style={{
                                        visibility: "hidden",
                                      }}
                                    />
                                  }
                                />
                                {CurrencyIcon[value.currency]}{" "}
                              </span>
                              <span
                                className={`${value?.fieldValue < 0 && "text-danger"
                                  } text-end w-100`}
                              >
                                {formatMoneyWithCurrency(Math.round(value?.fieldValue), value.currency, false) || 0}
                              </span>
                            </div>
                          )}
                        </Table.Cell>
                      );
                  })}
                </Table.Row>
              );
            })}
          </Table.Body>
        </Table>
      </div>
    </div>
  );
}